import UmlFreePoint from './UmlFreePoint';

// Buigpunt binnen een UmlConnector.points[]. Eerste-klas item, geen los coördinaat-object.
class UmlConnectorPoint extends UmlFreePoint {
  constructor(id, x, y, connectorId) {
    super(id, x, y);
    this.connectorId = connectorId;
  }
}

export default UmlConnectorPoint;
